<template>
    <v-container grid-list-xl :class="$vuetify.breakpoint.smAndDown ? 'px-0' : ''">
        <v-card flat v-if="Object.values(basketItems).length > 0">
            <v-card-title primary-title>
                <h3 class="headline mb-0">
                    {{ 'We found saved items in your account. Would you like to add these items back to the cart?' | translation }}?
                </h3>
            </v-card-title>

            <basket-items
                :items="basketItems"
                no-totals
                no-controls
            />
            <v-card flat class="text-xs-right">
                <v-btn
                    color="primary"
                    @click="mergeBaskets"
                >
                    {{ 'Add' | translation }}
                </v-btn>
            </v-card>

            <v-card flat class="text-xs-right">
                <v-btn
                    color="primary"
                    @click="addOnlyLocalBasket"
                >
                    {{ 'Do not add' | translation }}
                </v-btn>
            </v-card>
        </v-card>
    </v-container>
</template>

<script>
import Vue from 'vue';
import Basket from './Basket';

const moduleName = 'MergeBaskets';

export default {
    name: moduleName,
    extends: Basket,
    computed: {
        basketItems() {
            let serverItems = Object.assign({}, this.$basket.getServerBasket().items);
            let localItems = this.$basket.getBasketItems();
            const basketItems = this.$basket.getServerBasket().items;
            Object.keys(basketItems).forEach(i => {
                Object.keys(localItems).forEach(n => {
                    if (localItems[n].catalog_item_id == basketItems[i].catalog_item_id) {
                        Vue.delete(serverItems, i);
                    }
                });
            });
            return serverItems;
        },
    },
    methods: {
        mergeBaskets() {
            this.$basket.mergeBaskets(false);
            this.$router.push({ name: 'basket' });
        },
        addOnlyLocalBasket() {
            this.$basket.removeServerBasket();
            this.$router.push({ name: 'basket' });
        },
    },
};
</script>